import {
    BLOGS_ADD_NEW_COMMENT_PLACEHOLDER,
    FORUM_COMMENT_FORM_EMPTY_MESSAGE_CANNOT_BE_SENT,
    SEND_COMMENT_FORUM,
} from 'mk/autogenerated/translations/BlogPostCommentCreateForm.bee9575e255bf150748664d0d29aade1'
import { CommentFormData } from 'mk2/apps/forum/components/CommentCreateEditForm';
import { BtnType } from 'mk2/components/Btn';
import SubmitButton from 'mk2/components/forms/SubmitButton';
import TextareaField from 'mk2/components/forms/TextareaField';
import { ComposeToolbar } from 'mk2/containers/Toolbar/Toolbar';
import { MKReduxFormInjectedProps, mkReduxFormNew } from 'mk2/helpers/form';
import * as React from 'react';
import { FormErrors } from 'redux-form';
import styles from './BlogPostCommentCreateForm.mscss';

interface OwnProps {
    isDesktop: boolean;
    isIOS: boolean;
    initialValues: CommentFormData;
    requestUserPermissions: string[];

    textareaRef?: (r: HTMLTextAreaElement) => void;
    onSave(values: CommentFormData);
}

type Props = OwnProps;

const emojisConfig = {
    fields: [ 'text' ],
    defaultField: 'text',
};

const photosConfig = {
    photoType: 'comment',
    multiple: false,
    previewPhotoSize: 's150x150',
    showPhotoCode: false,
};

class BlogPostCommentCreateFormComponent extends React.Component<Props & MKReduxFormInjectedProps> {

    public static validate(values: CommentFormData): FormErrors<CommentFormData> {
        const errors: FormErrors<CommentFormData> = {};
        if (!values.text && (!values.photos || !values.photos.length) && !values.sticker) {
            errors.text = FORUM_COMMENT_FORM_EMPTY_MESSAGE_CANNOT_BE_SENT;
        }

        return errors;
    }

    public render() {
        const { textareaRef, requestUserPermissions } = this.props;
        const { form, handleSubmit } = this.props;
        const isAdmin = requestUserPermissions.indexOf('users.can_manage_groups') >= 0;
        return (
            <form
                className={styles.BlogPostCommentCreateForm}
                onSubmit={handleSubmit}
            >
                <ComposeToolbar
                    className={styles.BlogPostCommentCreateForm__toolbar}
                    formName={form}
                    emojis={emojisConfig}
                    photos={photosConfig}
                    isFixed={false}
                    isInGroups
                    rightAction={
                        <SubmitButton
                            className={styles.BlogPostCommentCreateForm__submit}
                            canBeVisuallyDisabled={false}
                            label={SEND_COMMENT_FORUM}
                            formName={form}
                            btnType={BtnType.BlueOutline}
                        />
                    }
                    textArea={
                        <div
                            className={styles.BlogPostCommentCreateForm__textareaWrapper}
                        >
                            <div className={styles.BlogPostCommentCreateForm__textareaWrapper__lvl2}>
                                <TextareaField
                                    name="text"
                                    rows={1}
                                    maxRows={
                                        // vidno max 5 riadkov textu, potom sa spravi scrollbar
                                        5
                                    }
                                    placeholder={
                                        // kvoli ios, musime vykrelist ako placeholder={} a nie ako hint={},
                                        // aby bol kurzor dobre zaindentovany
                                        BLOGS_ADD_NEW_COMMENT_PLACEHOLDER}
                                    bottomBorder={false}
                                    marginLeft={false}
                                    textareaRef={textareaRef}
                                    isCompact
                                />
                            </div>
                        </div>
                    }
                />
            </form>
        );
    }
}

export const BlogPostCommentCreateFormFactory = (formName: string) => mkReduxFormNew<CommentFormData, Props>({
    formName,
    photosConfig,
    onValidate: (values) => BlogPostCommentCreateFormComponent.validate(values),
    onSave: (values, props) => props.onSave(values),
})(BlogPostCommentCreateFormComponent);
